import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import UploadIcon from '@atlaskit/icon/core/upload';

import { Ati } from '@atlassian/ari';

import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs';
import { useHardStorageEnforcement } from '@confluence/storage-enforcement/entry-points/HardEnforcement/useHardStorageEnforcement';
import { GlobalImportModal } from '@confluence/import-from-sources';

import type { UseMenuItemProps, UseMenuItemReturnProps } from '.';

const messages = defineMessages({
	title: {
		id: 'create-blank-fabric-page.universal-create.import.title',
		defaultMessage: 'Import',
		description: 'title indicating that this option will import a document.',
	},
});

export function useImportSourceItem({
	parentId,
	spaceKey,
	onClick,
}: UseMenuItemProps): UseMenuItemReturnProps {
	const { formatMessage } = useIntl();

	const { showModal } = useDialogs();
	const { enforceStorageLimit, shouldBlockCreate } = useHardStorageEnforcement({
		source: 'import-popover-item',
	});

	const handleClick = useCallback(() => {
		if (shouldBlockCreate) {
			return;
		}

		showModal(GlobalImportModal, {
			contentId: parentId,
			hasUserAddedContent: false,
			currentSpace: spaceKey,
		});

		onClick('importSourcesPopoverItem');
	}, [shouldBlockCreate, showModal, parentId, spaceKey, onClick]);

	return {
		ati: Ati.parse('ati:cloud:confluence:attachment'),
		children: formatMessage(messages.title),
		onClick: enforceStorageLimit(handleClick),
		elemBefore: <UploadIcon label="" />,
		testId: 'create-menu-button-item',
	};
}
